'use client'

import React from 'react'
import dynamic from 'next/dynamic'
import { notFound } from 'next/navigation'
import { findAssetBySlug } from '../_assets'

/**
 * MarketShell reads window-dimension-derived state (via useWindowSize)
 * at the top of its render. That's a hydration landmine: the server
 * falls back to width=0 (mobile), and the client's first render reads
 * the real width (often desktop). Skip SSR for the trading UI — it's
 * gated, the data is client-fetched anyway, and we already SEO via
 * the static metadata + an sr-only h1 inside MarketShell.
 *
 * Why this component receives the slug instead of the AssetConfig:
 * server components can't serialize functions across the RSC boundary,
 * and the BTC asset config includes `getUserAddress`. Looking the
 * config up here (on the client) bypasses the boundary entirely.
 */
const MarketShell = dynamic(() => import('../_components/market-shell'), {
	ssr: false
})

export default function MarketClient({ slug }: { slug: string }) {
	const asset = findAssetBySlug(slug)
	if (!asset) {
		// Server validated the slug before render, but guard anyway in
		// case the asset gets removed from the registry while a stale
		// SSR-cached page is still navigating.
		notFound()
	}
	return <MarketShell asset={asset} />
}
